/* DIX 2026 — Rendre le total prévisible avant le checkout.
   1. Barre de progression vers la livraison gratuite
   2. Estimation taxes + livraison + total
   3. Mention sous le prix (fiche produit)
   Fonctionne sur la page /cart ET dans le tiroir Vitals. */
(function () {
  var CFG = {
    CA: { threshold: 8999, ship: 999, tax: 0.14975, taxLabel: 'Taxes estimées (TPS + TVQ)' },
    US: { threshold: 9000, ship: 1200, tax: 0, taxLabel: '' }
  };

  function country() {
    try { if (window.Shopify && Shopify.country) return String(Shopify.country).toUpperCase(); } catch (e) {}
    return 'CA';
  }
  function isEN() { return (document.documentElement.lang || 'fr').toLowerCase().indexOf('en') === 0; }
  function money(c) {
    var v = (c / 100);
    return isEN() ? '$' + v.toFixed(2) : v.toFixed(2).replace('.', ',') + ' $';
  }
  function money0(c) {
    var v = Math.round(c / 100);
    return isEN() ? '$' + v : v + ' $';
  }
  function cfg() { return CFG[country()] || CFG.CA; }

  /* Promo Halloween : livraison gratuite sans minimum jusqu'au 31 octobre 2026, 23h59 (heure du Québec).
     Après cette date, tout revient automatiquement au seuil habituel. */
  var PROMO_END = Date.parse('2026-10-31T23:59:59-04:00');
  function promo() { return Date.now() < PROMO_END; }

  /* Livraison gratuite atteinte ? Un seul endroit décide, pour éviter
     que la barre et l'estimation ne se contredisent. */
  function freeShip(total) { return promo() || total >= cfg().threshold; }

  function barMarkup(total) {
    var c = cfg(), en = isEN();
    if (promo()) {
      var ptxt = en
        ? '🎃 <b>Free shipping</b> on your order. Halloween offer until October 31.'
        : '🎃 <b>Livraison gratuite</b> sur ta commande. Offre d’Halloween jusqu’au 31 octobre.';
      return '<p class="dxfs-t is-done">' + ptxt + '</p>'
        + '<div class="dxfs-bar"><span class="dxfs-fill" style="width:100%"></span></div>';
    }
    var left = Math.max(0, c.threshold - total);
    var pct = Math.max(0, Math.min(100, (total / c.threshold) * 100));
    var txt = left <= 0
      ? (en ? '<b>Free shipping unlocked.</b> Nothing more to add.' : '<b>Livraison gratuite débloquée.</b> Rien à ajouter.')
      : (en ? 'Only <b>' + money(left) + '</b> away from <b>free shipping</b>' : 'Plus que <b>' + money(left) + '</b> pour la <b>livraison gratuite</b>');
    return '<p class="dxfs-t' + (left <= 0 ? ' is-done' : '') + '">' + txt + '</p>'
      + '<div class="dxfs-bar"><span class="dxfs-fill" style="width:' + pct.toFixed(1) + '%"></span></div>';
  }

  function estMarkup(total) {
    var c = cfg(), en = isEN();
    var ship = freeShip(total) ? 0 : c.ship;
    var tax = Math.round(total * c.tax);
    var rows = '';
    if (c.tax > 0) rows += '<div class="dxest-l"><span>' + (en ? 'Estimated taxes (GST + QST)' : c.taxLabel) + '</span><span>' + money(tax) + '</span></div>';
    rows += '<div class="dxest-l"><span>' + (en ? 'Shipping' : 'Livraison') + '</span><span>'
      + (ship === 0 ? (en ? 'Free' : 'Gratuite') : money(ship)) + '</span></div>';
    var note = en ? 'Estimate based on Quebec rates. Final amount confirmed at checkout.'
                  : 'Estimation au taux du Québec. Le montant exact est confirmé au paiement.';
    return rows
      + '<div class="dxest-tot"><span>' + (en ? 'Estimated total' : 'Total estimé') + '</span><span>' + money(total + ship + tax) + '</span></div>'
      + (c.tax > 0 ? '<p class="dxest-note">' + note + '</p>' : '');
  }

  function guarMarkup() {
    var en = isEN();
    var title = en ? 'Satisfied or your money back — 30 days' : 'Satisfait ou remboursé — 30 jours';
    var sub = en ? 'Try your jewelry risk-free and get a full refund if you change your mind.'
                 : 'Essaie tes bijoux sans risque et fais-toi rembourser si tu changes d’idée.';
    return '<div class="dxguar-txt"><span class="dxguar-t">' + title + '</span><span class="dxguar-s">' + sub + '</span></div>';
  }

  function put(el, html) { if (el && el.innerHTML !== html) el.innerHTML = html; }

  function mountPage(total) {
    var main = document.querySelector('#MainContent') || document.querySelector('main');
    var items = main && (main.querySelector('#main-cart-items') || main.querySelector('.cart__items'));
    if (items) {
      var host = items.closest('.cart__contents') || items.parentElement;
      var bar = host.querySelector(':scope > .dxfs');
      if (!bar) { bar = document.createElement('div'); bar.className = 'dxfs'; host.insertBefore(bar, items); }
      put(bar, barMarkup(total));
    }
    var totals = document.querySelector('.totals');
    if (totals && totals.parentElement) {
      var est = totals.parentElement.querySelector(':scope > .dxest');
      if (!est) { est = document.createElement('div'); est.className = 'dxest'; totals.parentElement.insertBefore(est, totals.nextSibling); }
      put(est, estMarkup(total));
    }
    var footer = document.querySelector('.cart__footer');
    if (footer) {
      var guar = footer.querySelector(':scope > .dxguar');
      if (!guar) { guar = document.createElement('div'); guar.className = 'dxguar'; footer.insertBefore(guar, footer.firstChild); }
      put(guar, guarMarkup());
    }
  }

  function mountDrawer(total) {
    var d = document.querySelector('.Vtl-CartDrawer__Container');
    if (!d) return;
    var topBar = d.querySelector(':scope > .dxfs');
    if (topBar) topBar.remove();
    var btnC = d.querySelector('.Vtl-CartDrawerCheckout__CheckoutButtonContainer');
    if (!btnC || !btnC.parentElement) return;
    var parent = btnC.parentElement;
    var bar = parent.querySelector(':scope > .dxfs');
    if (!bar) {
      bar = document.createElement('div');
      bar.className = 'dxfs dxfs--lt';
      parent.insertBefore(bar, btnC);
    } else if (bar.nextElementSibling !== btnC) {
      parent.insertBefore(bar, btnC);
    }
    put(bar, barMarkup(total));
  }

  function render(total) { if (total != null) { mountPage(total); mountDrawer(total); } }

  var busy = false;
  function refresh() {
    if (busy) return;
    busy = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { busy = false; if (c && c.item_count > 0) render(c.total_price); })
      .catch(function () { busy = false; });
  }

  var t = null;
  function soon() { clearTimeout(t); t = setTimeout(refresh, 350); }

  function watch() {
    refresh();
    document.addEventListener('click', function (e) {
      if (e.target.closest('.cart-item, .cart__items, quantity-input, .Vtl-CartDrawer__Container, .header__icon--cart, [href$="/cart"]')) {
        setTimeout(refresh, 600); setTimeout(refresh, 1500);
      }
    });
    window.addEventListener('pageshow', refresh);
    if ('MutationObserver' in window) {
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var tg = muts[i].target;
          if (tg && tg.closest && tg.closest('.dxfs, .dxest, .dxguar')) continue;
          soon();
          return;
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  function productLine() {
    var el = document.querySelector('.product__tax');
    if (!el) return;
    var c = cfg(), en = isEN();
    if (promo()) {
      el.innerHTML = en
        ? '<span class="dxpt-hl">🎃 Free shipping</span> · until October 31 · taxes extra'
        : '<span class="dxpt-hl">🎃 Livraison gratuite</span> · jusqu’au 31 octobre · taxes en sus';
      return;
    }
    el.innerHTML = en
      ? '<span class="dxpt-hl">Free shipping over ' + money0(c.threshold + 1) + '</span> · taxes extra'
      : '<span class="dxpt-hl">Livraison gratuite dès ' + money0(c.threshold + 1) + '</span> · taxes en sus';
  }

  function start() { watch(); productLine(); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', start); } else { start(); }
})();

/* DIX 2026 — Fiche produit : réassurance sous les boutons + bouton d'ajout collant (mobile). */
(function () {
  function isEN() { return (document.documentElement.lang || 'fr').toLowerCase().indexOf('en') === 0; }
  function mainScope() { return document.querySelector('#MainContent') || document; }
  function realSubmit() {
    var s = mainScope();
    return s.querySelector('product-form .product-form__submit') || document.querySelector('product-form .product-form__submit');
  }
  function priceText() {
    var s = mainScope();
    var box = s.querySelector('.product__info-container .price') || s.querySelector('.price');
    if (!box) return '';
    var sale = box.querySelector('.price-item--sale');
    var reg = box.querySelector('.price-item--regular');
    var el = (sale && (sale.offsetParent !== null) && (sale.textContent || '').trim()) ? sale : (reg || box);
    return (el.textContent || '').replace(/\\s+/g, ' ').trim();
  }
  function titleText() {
    var s = mainScope();
    var h = s.querySelector('.product__title h1') || s.querySelector('.product__title') || s.querySelector('h1');
    return h ? (h.textContent || '').trim() : '';
  }

  function mountReassurance() {
    var buttons = mainScope().querySelector('.product-form__buttons');
    if (!buttons || !buttons.parentElement) return;
    if (buttons.parentElement.querySelector(':scope > .dxrass')) return;
    var en = isEN();
    var items = en
      ? [['lock', 'Secure checkout'], ['truck', 'Ships from Quebec'], ['return', '30-day returns']]
      : [['lock', 'Paiement sécurisé'], ['truck', 'Expédié du Québec'], ['return', 'Retours 30 jours']];
    var div = document.createElement('div');
    div.className = 'dxrass';
    div.innerHTML = items.map(function (it) { return '<span class="dxrass-i dxrass-' + it[0] + '">' + it[1] + '</span>'; }).join('');
    buttons.parentElement.insertBefore(div, buttons.nextSibling);
  }

  var sticky = null;
  function buildSticky() {
    if (sticky) return sticky;
    sticky = document.createElement('div');
    sticky.className = 'dxsticky';
    sticky.innerHTML = '<div class="dxsticky-info"><span class="dxsticky-title"></span><span class="dxsticky-price"></span></div>'
      + '<button type="button" class="dxsticky-btn">' + (isEN() ? 'Add to cart' : 'Ajouter au panier') + '</button>';
    document.body.appendChild(sticky);
    sticky.querySelector('.dxsticky-btn').addEventListener('click', function () {
      var b = realSubmit();
      if (b) { b.scrollIntoView({ block: 'center' }); b.click(); }
    });
    return sticky;
  }
  function syncSticky() {
    if (!sticky) return;
    sticky.querySelector('.dxsticky-title').textContent = titleText();
    sticky.querySelector('.dxsticky-price').textContent = priceText();
    var real = realSubmit(), b = sticky.querySelector('.dxsticky-btn');
    if (real) {
      var off = real.hasAttribute('disabled');
      b.disabled = off;
      b.textContent = off ? 'Épuisé' : (isEN() ? 'Add to cart' : 'Ajouter au panier');
      if (isEN() && off) b.textContent = 'Sold out';
    }
  }
  function initSticky() {
    var real = realSubmit();
    if (!real) return;
    buildSticky();
    syncSticky();
    var anchor = mainScope().querySelector('.product-form__buttons') || real;
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        document.body.classList.toggle('dxsticky-on', !entries[0].isIntersecting);
      }, { rootMargin: '0px 0px -8px 0px' }).observe(anchor);
    } else {
      document.body.classList.add('dxsticky-on');
    }
    var priceEl = mainScope().querySelector('.product__info-container .price') || mainScope().querySelector('.price');
    if (priceEl && 'MutationObserver' in window) {
      new MutationObserver(function () { syncSticky(); }).observe(priceEl, { childList: true, subtree: true, characterData: true });
    }
    document.addEventListener('change', function (e) {
      if (e.target.closest && e.target.closest('variant-selects, .product-form, [name="id"]')) setTimeout(syncSticky, 60);
    });
  }

  function start() {
    if (!realSubmit()) return;
    mountReassurance();
    initSticky();
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', start); } else { start(); }
})();